export const analytics = {
  title: "Statistiche",
  subtitle: "Entrate e occupazione delle tue proprietà nel periodo che scegli.",
  tabs: {
    performance: "Rendimento",
    channels: "Canali",
  },
  allAccommodations: "Tutti gli alloggi",
  compare: {
    prevPeriod: "Periodo precedente",
    prevYear: "Anno precedente",
    titlePrevPeriod: "Confronto: periodo precedente",
    titlePrevYear: "Confronto: anno precedente",
    inlinePrevPeriod: "periodo precedente",
    inlinePrevYear: "anno precedente",
  },
  summary: {
    currentPeriod: "Periodo attuale",
    paymentFilter: "Filtro pagamenti",
  },
  presets: {
    today: "Oggi",
    yesterday: "Ieri",
    d7: "7 giorni",
    d30: "30 giorni",
    m3: "3 mesi",
    m6: "6 mesi",
    year: "1 anno",
  },
  payment: {
    all: "Tutti i pagamenti",
    pending: "In sospeso",
    paid: "Pagato",
    rejected: "Rifiutato",
    refunded: "Rimborsato",
    partial: "Pagamento parziale",
  },
  kpi: {
    totalRevenue: "Ricavi del periodo",
    arrivalRevenue: "Valore totale degli arrivi",
    revpar: "RevPAR",
    occupancyRate: "Tasso di occupazione",
    adr: "ADR",
    avgStay: "Soggiorno medio",
    bookingWindow: "Finestra di prenotazione",
  },
  units: {
    days: " giorni",
  },
  chart: {
    thisPeriod: "Questo periodo",
    subtitle: "{current} · rispetto a {compared} · {payment}",
  },
  channels: {
    directBookings: "Prenotazioni dirette",
    otaBookings: "Prenotazioni OTA",
    bookingDetails: "Dettaglio prenotazioni",
    byChannel: "Per canale",
    tableChannel: "Canale",
    tableRevenue: "Ricavi",
    direct: "Dirette",
    ota: "OTA",
    noData: "Nessun dato per il periodo selezionato",
  },
  a11y: {
    chartOf: "Grafico di {label}",
    directVsOta: "Grafico prenotazioni dirette vs OTA",
  },
};
